export const serviceSessionStorage = {
  setPaginationRows: (page, size) => {
    const pagination = JSON.parse(sessionStorage.getItem('pagination')) || {};
    pagination[page] = size;
    sessionStorage.setItem('pagination', JSON.stringify(pagination));
  },
  getPaginationRows: (page) => {
    const pagination = JSON.parse(sessionStorage.getItem('pagination'));
    return pagination?.[page];
  },
};
